import {
  ChangeDetectionStrategy,
  Component,
  effect,
  inject,
  input,
  model,
  OnInit,
  signal,
} from '@angular/core';
import { MultiSelectComponent } from '../multi-select.component';

@Component({
  selector: 'app-multi-select-checkbox',
  imports: [],
  templateUrl: './multi-select-checkbox.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MultiSelectCheckboxComponent implements OnInit {
  public label = input<string>();
  public value = input<any>();
  public checked = model<boolean>(false);

  public isChecked = signal<boolean>(false);
  public isVisible = signal<boolean>(true);

  private parent = inject(MultiSelectComponent, { optional: true, host: true });

  constructor() {
    effect(() => {
      this.check();
    });
  }

  ngOnInit(): void {
    this.isChecked.set(this.checked());
    if (this.isChecked()) {
      this.parent?.apply();
    }
  }

  public check() {
    this.isChecked.set(this.parent?.value()?.includes(this.value()));
  }

  protected onToggle(event: Event) {
    this.isChecked.set((event.target as HTMLInputElement).checked);
    if (!this.parent?.footer()) {
      if (this.isChecked()) {
        this.parent?.value.update((state) => [
          ...(state ?? []),
          this.value() ?? [],
        ]);
      } else {
        this.parent?.value.update(
          (state) => state?.filter((value) => value !== this.value()) ?? []
        );
      }
      this.parent?.apply();
    }

    if (this.parent?.isGroupParentCheckbox(this)) {
      this.parent?.updateGroupParent(this);
      this.parent?.refreshSearch();
    } else {
      this.parent?.refreshSearch();
    }
  }

  protected readonly JSON = JSON;
}
